import React from "react";
import { hydrateRoot } from "react-dom/client";
import { createRouter } from "./libraries/universal-route/router.js";
import routes from "./routes/hiring-react-routes";
import { StateProvider, StateContext } from "./store.js";
import "./static/css/hiring.scss";

const Router = createRouter(routes, StateContext);

hydrateRoot(
  document.getElementById("app"),
  <StateProvider>
    <Router />
  </StateProvider>
);
